export default __webpack_public_path__ + "static/solution_back-c608e41f4d79578719899a2634307098.webp";